var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#fff}"))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    style: {
      fill: "#f00075"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20 8.7a6.12 6.12 0 0 0-.37-1.94 4.12 4.12 0 0 0-2.34-2.34 5.92 5.92 0 0 0-1.95-.37h-6.6a5.61 5.61 0 0 0-1.94.37 3.91 3.91 0 0 0-1.42.92 4 4 0 0 0-.92 1.42 6.12 6.12 0 0 0-.41 1.94C4 9.56 4 9.83 4 12v3.3a5.61 5.61 0 0 0 .37 1.94 4 4 0 0 0 .92 1.42 3.91 3.91 0 0 0 1.42.92A5.61 5.61 0 0 0 8.7 20c.86 0 1.13.05 3.3.05s2.44 0 3.3-.05a5.61 5.61 0 0 0 1.94-.37 4 4 0 0 0 2.34-2.34A5.61 5.61 0 0 0 20 15.3c0-.85.05-1.13.05-3.3S20 9.56 20 8.7zm-1.44 6.54a4.44 4.44 0 0 1-.28 1.48 2.65 2.65 0 0 1-1.52 1.52 4.44 4.44 0 0 1-1.48.28H8.81a4.44 4.44 0 0 1-1.48-.28 2.45 2.45 0 0 1-.92-.6 2.49 2.49 0 0 1-.6-.91 4.39 4.39 0 0 1-.27-1.49V8.78a4.28 4.28 0 0 1 .27-1.49 2.45 2.45 0 0 1 .6-.92 2.57 2.57 0 0 1 .92-.6 4.33 4.33 0 0 1 1.45-.27h6.46a4.33 4.33 0 0 1 1.49.27 2.66 2.66 0 0 1 .92.6 2.55 2.55 0 0 1 .59.92 4.52 4.52 0 0 1 .28 1.49c0 .84.05 1.09.05 3.23s-.01 2.38-.05 3.23z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12 7.89A4.11 4.11 0 1 0 16.11 12 4.11 4.11 0 0 0 12 7.89zm0 6.78A2.67 2.67 0 1 1 14.67 12 2.67 2.67 0 0 1 12 14.67zm5.24-6.94a1 1 0 1 1-1-1 1 1 0 0 1 1 1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.4d57f807d5af329f514d67e9bd9b6ab6.svg";
export { ForwardRef as ReactComponent };